 <template>
    <div class="overviewRight ">
      <div class="account-bottom white border border-radius5 mar-bot10">
        <div class="chart-other-box pc-padding30-mobil-padding20">
          <div class="top-modules blod theme-font-color">
            <icon-svg
              icon-class="MAMzhuangtai"
              class="icon-el people-icon"
            ></icon-svg>
            MAM {{$t('state')}}
          </div>
          <div class="copy-set-status">
            <span
              v-if="detailsIsMaster"
              class="is-open tag-box tag"
              :style="isOpenStyle"
            >{{isOpenText}}</span>
            <span
              v-if="isOpen"
              class="is-open tag-box tag"
              :style="isPassStyle"
            >{{isPassText}}</span>
          </div>

          <div class="strategy">
            <h3 class="fs14 blod font333 mar-bot10 icon-outer-el theme-font-color">
              <icon-svg
                icon-class="celve"
                class="icon-el strategy-icon"
              ></icon-svg>
              {{$t('copyMaster.strategy')}}
            </h3>
            <p class="strategy-text">{{strategy || $t('No')}}</p>
          </div>
          <div class="pay-details"
          >
            <!--不能超过账户余额-->
            <h4 class="fs14 blod font333 mar-bot10 icon-outer-el theme-font-color">
<!--              <img src="../../../../../assets/images/icon/price.png" alt="">-->
              <icon-svg
                icon-class="feiyong"
                class="icon-el cost-icon"
              ></icon-svg>
              {{$t('cost')}}
            </h4>
            <div class="mam-pay-way"
            >
              <span v-if="isFree">{{$t('free')}}</span>
              <div
                v-if="!isFree"
                class="subtitle fs12">
                {{$t('management_fee')}}
                <span class="theme-color">{{price}}</span>，{{$t('Charged_when_the_trading_cycle_is_enabled_Performance_fees_are_as_shown_below_and_are_charged_at_settlement')}}
              </div>
              <div
                v-if="!isFree"
                class="mam-pay-details-money">
                <el-row class="odd-box line-box"
                >
                  <el-col :span="12">
                    {{$t('rate_of_return')}}
                  </el-col>
                  <el-col :span="12">
                    {{$t('Share_ratio')}}
                  </el-col>
                </el-row>
                <el-row
                  class="line-box"
                  :class="{'odd-box': index % 2 !== 0}"
                  v-for="(item,index) in extraPrice"
                  :key="index"
                >
                  <el-col :span="12">
                    {{item.profitValue}}
                  </el-col>
                  <el-col :span="12">
                    {{item.shareValue}}
                  </el-col>
                </el-row>
              </div>
            </div>

            <vs-button
              v-if="detailsIsMaster"
              @click="copySettingHandle"
              class="copy-vs-btn"
            >{{$t('Copy_settings')}}</vs-button>
          </div>
        </div>
      </div>
      <div class="account-header white  border-radius5">
          <div
            ref="echartup"
             class="chart-box pc-padtop30-mobil-padtop20">
            <account-bar
              :chart-width="echarWidth"
              :height="echarHeight"
              :chart-list="levelData"
            ></account-bar>
          </div>
          <div class="rate-box center">
            <el-rate
              disabled
              :value="recommendStar"
              show-score
              :colors="[orange,orange,orange]"
              text-color="#999999"
            ></el-rate>
          </div>
          <div class="copy-btn-outer">
            <el-button
              size="smalll"
              v-if="isOpen"
              type="primary"
              class="copy-btn"
              @click="copyHandle"
            >{{$t('subscription')}}</el-button>

            <el-tooltip
              v-if="isOpen === 0"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                {{$t('noOpenTips')}}
              </div>
              <el-button
                size="smalll"
                v-if="!isOpen"
                class="copy-btn disabled"
              >{{$t('subscription')}}</el-button>
            </el-tooltip>
          </div>
          <div class="money-limit center">
            {{$t('Minimum_funding_limit')}} {{moneyLimit}} USD
          </div>
        </div>
      <mam-master-copy-setting-dialog
        :dialog-show="masterCopySetDialogShow"
        :account-mt-id="$route.params.mtid"
        @close="masterCopySetDialogShow = false"
        @ajax-success="setSuccess"
      ></mam-master-copy-setting-dialog>
    </div>
</template>

<script>
    import mamMasterCopySettingDialog from '@/components/copyMaster/home/mamMasterCopySettingDialog'
    import { colorRgba } from "@/utils";
    import accountIndexDataNew from "@/components/common/accountIndexDataNew";
    import { mapGetters } from 'vuex'
    import { getTraderOverview } from '@/api/copy'
    import accountBar from '@/components/echarts/accountBar'
  export default {
    name: 'overviewRight',
    props: {
      overviewInfo: {
        type: Object,
        default(){
          return {}
        }
      },
    },
    components:{
      accountBar,
      accountIndexDataNew,
      mamMasterCopySettingDialog,
    },
    data() {
      return {
        echarWidth: 0,
        echarHeight: 184,
        levelData:[],
        recommendStar: 0,
        orange: '#FF7F5A',
        alias: '',
        login: '', // todo
        businessType: '',
        experienceDay: '',
        strategy: '',
        price: '',
        extraPrice: [],
        copyMoneyMonthly: 0,
        moneyLimit: '',
        isOpen: 1,
        isFree: 1,
        isEncrypt: false, // 有没有

        green: '#28C76F',
        red: '#EA5455',

        masterCopySetDialogShow: false,
      };
    },
    watch:{
      overviewInfo:{
        handler(val){
          if(val){
          }
        },
        deep: true
      }
    },
    created(){
      this.getOverView();
    },
    mounted(){
        this.echarWidth = this.$refs.echartup.clientHeight;
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster']),
      isOpenText(){
        return this.isOpen ? this.$t('copyMaster.public'): this.$t('copyMaster.private');
      },
      isPassText(){
        if(this.isEncrypt){
          return this.$t('copyMaster.Have_a_subscription_password');
        }else {
          return this.$t('copyMaster.No_subscription_password');
        }
      },
      isOpenStyle(){
        if(this.isOpen){
          return {
            backgroundColor: colorRgba(this.green,0.1),
            color: this.green,
          }
        }else {
          return {
            backgroundColor: colorRgba(this.red,0.1),
            color: this.red,
          }
        }
      },
      isPassStyle(){
        if(this.isEncrypt){
          return {
            backgroundColor: colorRgba(this.red,0.1),
            color: this.red,
          }
        }else {
          return {
            backgroundColor: colorRgba(this.green,0.1),
            color: this.green,
          }
        }
      },
    },
    methods: {
      setSuccess(){
        this.masterCopySetDialogShow = false;
        this.getOverView();
      },
      getOverView(){

        getTraderOverview({
          mtId: this.$route.params.mtid,
        }).then((res) => {

          this.alias = res.data.alias;
          this.login = res.data.login;
          this.moneyLimit = res.data.subAmount;
          this.isOpen = res.data.isOpen;
          this.isEncrypt = res.data.isEncrypt;
          this.copyMoneyMonthly = res.data.price;
          this.businessType = res.data.businessType;
          this.experienceDay = res.data.extraPrice;
          this.isFree = res.data.isFree;

          this.strategy = res.data.tradeStrategy;
          this.recommendStar = res.data.recommendStar;
          this.levelData.push(res.data.profitAbility || 0);
          this.levelData.push(res.data.robustAbility || 0);
          this.levelData.push(res.data.riskControlAbility || 0);
          this.levelData.push(res.data.capitalSize || 0);
          this.levelData.push(res.data.tradingActivity || 0);
          this.price = res.data.price;
          if(res.data.extraPrice && res.data.extraPrice.length){
            this.extraPrice = res.data.extraPrice;
          }
        })
      },
      copyHandle(){
        if(this.$route.name == 'socialMasterDetailsSimple' || this.$route.name == 'mamMasterDetailsSimple'){
          if(this.userInfo.id){
            if(this.$route.name == 'socialMasterDetailsSimple'){
              this.$router.push({name: 'socialMasterDetails', params: this.$route.params});
            }else {
              this.$router.push({name: 'mamMasterDetails', params: this.$route.params});
            }
          }else {
            this.$router.push({
              name: 'login',
              query: {...this.$route.query, redirectRouterName: this.$route.name == 'socialMasterDetailsSimple'? 'socialMasterDetails': 'mamMasterDetails'},
              params: this.$route.params
            });
          }
        }else {
          this.$store.commit('setCurrentMasterMtId', this.$route.params.mtid);

          if(this.businessType == 2){
            this.$store.commit('setMamSubscrpitDialogShow',true);
          }else {
            this.$store.commit('setSocialSubscrpitDialogShow',true);
          }
        }
      },

      copySettingHandle(){
        this.masterCopySetDialogShow = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
    .overviewRight {
      .account-header {
            padding: 30px;
            padding-bottom: 10px;
            .nickname-line {
                margin-bottom: 10px;
            }
            .nickname-title {
                display: inline-block;
                margin-right: 10px;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
            }
            .tag {
                background-color: rgba(255,127,90, .1);
                color: #FF7F5A;
            }
            .money-limit {
                color: #999999;
                margin-bottom: 20px;
            }

        }
      .copy-btn-outer {
        padding: 0 20px;
        margin-bottom: 10px;
      }
      .copy-btn {
        width: 100%;
        &.disabled {
          color: #ffffff;
          background-color: #cccccc;
          &:hover {
            color: #ffffff;
            background-color: #cccccc;
            border-color: #cccccc;
          }
        }
      }

      .rate-box {
        margin-bottom: 32px;
      }
      .strategy-text {
        font-size: 14px;
        color: #666666;
        background-color: rgba(186,191,199,0.12);
        border-radius: 5px;
        padding: 15px;
        margin-bottom: 30px;
      }
      .icon-outer-el {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          margin-right: 5px;
        }
      }
      .mam-pay-way {
        .subtitle {
          margin: 20px 0 10px;
        }
        .line-box {

          height: 34px;
          line-height: 34px;
          padding: 0 10px;
          &.odd-box {
            background-color: #F9FAFB;
          }
        }

      }

      .copy-vs-btn {
        margin-top: 24px;
        width: 100%;
        background-color: #ffffff!important;
        color: #6E6B7B;
        border: 1px solid #D8D6DE;
        &:hover {
          box-shadow: none!important;
        }
      }

      .mam-pay-details-money {
        border: 1px solid #EBE9F1;
        border-radius: 5px;
      }

      .charge-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .top-modules {
        margin-bottom: 14px;

      }
      .tag-box {
        border-radius: 16px!important;
        margin-right: 10px;
      }
      .copy-set-status {
        margin-bottom: 24px;
      }

      .icon-el {
        font-size: 16px;
      }
      .people-icon {
        color: #FE5924;
      }
      .strategy-icon {
        color: #68BF7B;
        margin-right: 5px;
      }
      .cost-icon {
        color: #FE8D24;
        margin-right: 5px;
      }
    }
</style>
